<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-02 14:10:23
 * @LastEditTime : 2020-01-21 09:24:41
 * @LastEditors  : Please set LastEditors
 -->
<!--  -->
<template>
  <div class="city-change">
    <a
      class="city-change-inner"
      @click="_cityChangeClickHandler"
    >
      <span style="font-size: 13px">{{cityName}}</span>
      <em v-bind:class="{triangle_rotate:ucsetting.tool.selectedStatus,triangle:true,tool_container_triangle:true}"></em>
    </a>

    <UCDistrictCity ref="ucCity"></UCDistrictCity>

  </div>
</template>

<script>
import UCDistrictCity from "./UCDistrictCity.vue";

import { UCDistictEvent, CityInfo } from "./UCDistrictJs.js";
// import { District, DistrictFilter, Districts } from "../model/District.js";

export default {
  name: "UCDistrict",
  data() {
    return {
      cityName: "兰州",

      ucsetting: {
        tool: {
          selectedStatus: false
        }
      },

      nameIsCity: false

      // options: provinceAndCityData,
      // selectedOptions: []
    };
  },

  components: { UCDistrictCity },

  computed: {},

  mounted() {
    this.init();
  },

  methods: {
    init() {
      let self = this;

      this.$refs.ucCity.on_cityClick(function(cityInfo) {
        self.ucsetting.tool.selectedStatus=false;
        self.$refs.ucCity.closePopu();

        if (cityInfo) {
          self.nameIsCity = true;

          self.cityName = cityInfo.name;
        }
      });
    },

    off_ucClick(callback)
    {
      if (callback) {
        this.$off(UCDistictEvent.UCDistrict_event_ucClick, callback);
      }
    },

    on_ucClick(callback) {
      if (callback) {
        this.$on(UCDistictEvent.UCDistrict_event_ucClick, callback);
      }
    },

    closeCityPopu() {
      this.ucsetting.tool.selectedStatus = false;
      this.$refs.ucCity.closePopu();
    },

    cityChange(mapLevel, mapExtent) {
      if (!this.nameIsCity) {
        let cityInfo = CityInfo.findCity(mapLevel, mapExtent);
        if (cityInfo) {
          this.cityName = cityInfo.name;
        }
      } else {
        this.nameIsCity = false;
      }
    },

    off_cityPickerChanger(callback)
    {
      this.$refs.ucCity.off_cityClick(callback);

    },

    on_cityPickerChanger(callback) {
      this.$refs.ucCity.on_cityClick(callback);

      // if (callback) {
      //   this.$on(UCDistictEvent.UCDistictEvent_cityPickerChanger, callback);
      // }
    },

    // _cityPickerChangeHandler(options) {
    //   if(!options)return;
    //   let self=this;

    //   let optionText = CodeToText[options[options.length-1]];

    //   let filter=new DistrictFilter();
    //   filter.searchWord=optionText;
    //   Districts.query(filter,
    //   function(districts){
    //     if(!districts || districts.length==0)return;

    //     let district=null;
    //     if(districts.length===1)
    //     {
    //       district=districts.objects[0];
    //     }
    //     else
    //     {
    //       district=districts.findByProviceName("甘肃省");
    //     }

    //     self.$emit(UCDistictEvent.UCDistictEvent_cityPickerChanger, district);
    //   },
    //   function(){

    //   });
    // },

    // _cityPickerClickHandler(value) {

    //   console.log(value);
    // },

    _cityChangeClickHandler() {
      this.ucsetting.tool.selectedStatus = !this.ucsetting.tool.selectedStatus;

      if (this.ucsetting.tool.selectedStatus) {
        this.$refs.ucCity.openPopu();
      } else {
        this.$refs.ucCity.closePopu();
      }

      this.$emit(UCDistictEvent.UCDistrict_event_ucClick);
    }
  }
};
</script>

<style lang="scss" scoped>
a:hover {
  color: #3385ff;
}

a {
  color: #000;
  float: left;
  text-decoration: none;
  height: 34px;
  cursor: pointer;
}

.city-change {
  margin-top: 6px;
  float: right;
  padding-left: 5px;
  position: relative;
  padding-right: 0;
  margin-right: 30px;
}

.city-change-inner {
  // float: left;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  color: #666;
  font-size: 12px;
  text-decoration: none;
  vertical-align: middle;
  position: relative;
}

.tool_container_triangle {
  margin-left: 5px;
  float: right;
  margin-top: 15px;
}

.triangle {
  width: 11px;
  height: 6px;
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-repeat: no-repeat;
  background-position: -339px -222px;
  transition: 0.3s;
}

.triangle_rotate {
  transform: rotate(180deg);
}
</style>